import React from 'react';

import './ColorPicker.css';

const colors = [
  '#7858fb',
  '#9c6dff',
  '#c344ff',
  '#ff519a',
  '#ff574c',
  '#ff9559',
  '#0040bd',
  '#1c8ff9',
  '#32c3d7',
  '#06c78d',
  '#6dbb52',
  '#d0be19'
];

const ColorPicker = ({ className = '', color = '', onChange }) => {
  const selectedColor = color.toLowerCase();

  return (
    <div className={`MyCirclePicker ${className}`}>
      <div className="picker-circle" role="menu">
        {colors.map(color => (
          <div
            key={color}
            role="menuitemradio"
            aria-checked={selectedColor === color}
            aria-label={color}
            className={selectedColor === color ? 'active picker-color' : 'picker-color'}
            onClick={() => {
              onChange(color);
            }}
            style={{ backgroundColor: color }}
          >
            <div className="picker-color-inner"></div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ColorPicker;
